import { Box, useTheme } from "@mui/material";
import { useEffect, useRef, useState } from "react";
import { tokens } from "../../../../../../theme";

import Text from "../../../../../../components/theme/text/Text";

import AddIcon from '@mui/icons-material/Add';
import PowerSettingsNewIcon from '@mui/icons-material/PowerSettingsNew';
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import MpAddWebshop from "../../../../../../components/global/ModalsProgression/MpAddWebshop/MpAddWebshop";
import MConfirmation from "../../../../../../components/global/Modals/MConfirmation";
import { RelationWebshopIntegrationCard } from "../../../../../../components/global/cards/other/WebshopIntegrationCard";
import ButtonGroup from "../../../../../../components/theme/buttons/ButtonGroup";
import DropdownButton from "../../../../../../components/theme/buttons/DropdownButton";
import Shbutton from "../../../../../../components/theme/buttons/Shbutton";
import ShDataGrid2 from "../../../../../../components/theme/datagrid2/ShDataGrid2";
import ShDataGridSelectedActions from "../../../../../../components/theme/datagrid2/ShDataGridSelectedActions";
import ShLabel from "../../../../../../components/theme/label/ShLabel";
import SidepanelLoader from "../../../../../../components/theme/sidepanel2/SidepanelLoader";
import ShLabelSkeleton from "../../../../../../components/theme/skeleton/ShLabelSkeleton";
import ShTextSkeleton from "../../../../../../components/theme/skeleton/ShTextSkeleton";
import { selectUserPermission } from "../../../../../../newapi/user/authentication/authSlice";
import { useGetWebshopCredentialsQuery, useBulkUpdateWebshopCredentialsMutation } from "../../../../../../newapi/webshop/webshopSlice";
import { getWebshopLogo } from "../../../../../../utils/logomapper";
import { UserPrivileges } from "../../../../../../utils/permissions";
import { WEBSHOP_FILTER_KEYS } from "../../../../../../components/global/DataGrid/Filter";
import { general_states } from "../../../../../../utils/staticEnums";
import { showToastMessageRequestError, showToastMessageUpdateRequest } from "../../../../../../utils/toasts";

const SpWebshopCredentialsDetails = SidepanelLoader(() => import("../../../../../../components/global/Sidepanels/SpWebshopCredentialsDetails/SpWebshopCredentialsDetails"));

const GridActions = (props, i18n) => {
    const theme = useTheme();
    useEffect(() => {},[props.open]);
    const {t} = useTranslation();

    return (      
        <ButtonGroup version={2}>
            {props.hasCreatePermission && (
            <Shbutton 
                onClick={() => props.handleOpen(true)}
                className={"group-btn"} 
                color={theme.palette.mode === "dark" ? "blue" : "primary"} 
                variant="contained" 
                endIcon={<AddIcon/>}>{t("new_saleschannel")}</Shbutton>
            )}
        </ButtonGroup>
    );
}

let gridOptions = {
    export:true,
    disableCustomActionsOnPhone: true,
    isSidepanel: true,
    filter: [WEBSHOP_FILTER_KEYS.RELATION,WEBSHOP_FILTER_KEYS.WAREHOUSE],
};

const Concept = (props) => {
    const { t, i18n } = useTranslation();
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const [isExtended,setIsExtended] = useState(false);
    const [spLoading, setSpLoading] = useState();

    const [config, setConfig] = useState({"all_credentials": true, "integrator": 0, "deactivated": true,"state":[general_states.CONCEPT]});
    const isFulfilment = useSelector((state) => state.settings.environment.isFulfilment);

    const hasCreatePermission = useSelector((state) => 
        selectUserPermission(state, [UserPrivileges.WEBSHOPCREDENTIALS_MANAGE])
    );
    
    const [addModalOpen, setAddModalOpen] = useState(false);
    const addModal = {
        open: addModalOpen,
        setOpen: setAddModalOpen
    }

    const handleClose = () => {
        setAddModalOpen(false);
      };

    const [selectedItems, setSelectedItems] = useState([]);
    const onSelected = (locSelectedItems) => {
        setSelectedItems(locSelectedItems);
    };

    const [activateModalOpen, setActivateModalOpen] = useState(false);
    const activateModal = {
        open: activateModalOpen,
        setOpen: setActivateModalOpen,
    };

    const [bulkUpdateWebshopCredentials, { isLoading: activateLoading }] = useBulkUpdateWebshopCredentialsMutation();

    const handleActivateWebshops = async () => {
        if (selectedItems.length === 0) return;
        if (activateLoading) return;

        try {
            const response = await bulkUpdateWebshopCredentials({
                ids: selectedItems,
                state: general_states.ACTIVE,
            }).unwrap();

            setSelectedItems([]); // Clear selection after successful update
            activateModal.setOpen(false);
            showToastMessageUpdateRequest(t, response);
        } catch (error) {
            console.error('Error activating webshops:', error);
            showToastMessageRequestError(t('error_activating_webshop'), t, error);
        }
    };

    const [webshopCredentialsId, setWebshopCredentialsId] = useState();
    const webshopCredentialsIdRef = useRef(webshopCredentialsId);
    
    const getWebshopCredentialDetails = (params) => {
        if (!params) return;
    
        const newwebshopCredentialsId = parseInt(params.row.id);
        // Only update state if the webshopCredentialsId has actually changed
        if (webshopCredentialsIdRef.current !== newwebshopCredentialsId) {
            if(!spLoading) {
                setSpLoading(true);
            }
            setWebshopCredentialsId(newwebshopCredentialsId);
            webshopCredentialsIdRef.current = newwebshopCredentialsId; // Update the ref to the new value
        }
        setIsExtended(true);
    };
    
    useEffect(() => {
        props.replaceView({
            ...props.config,
            gridOptions:gridOptions,
            mobileActions:<GridActions handleOpen={() => setAddModalOpen(true)} hasCreatePermission={hasCreatePermission}></GridActions>
        });

        return () => {
            // console.log("unmounting warehouse");
        }
    },[]);
    const columns = [
        {field: "description", headerName: t("channel") , flex:2, cellClassName: "webshop", renderCell : (cellValues) => {
            if(cellValues.row.skeleton) {
                return <ShTextSkeleton/>
            }

            const webshopLogo = getWebshopLogo(cellValues.row.webshop_type,{theme,colors});
            return (
                <>
                <Box sx={{ paddingRight: '10px' }}>
                    {webshopLogo}
                </Box>
                <Text semibold variant={theme.palette.mode === "dark" ? "blue" : "primary"}>{cellValues.value}</Text>
                </>
            )
        }},
        ...isFulfilment ? [{field: "relation", headerName: t("relation") , flex:2, filter: WEBSHOP_FILTER_KEYS.RELATION, cellClassName: "relation", renderCell : (cellValues) => {
                if(cellValues.row.skeleton) {
                    return <ShTextSkeleton/>
                }

                return (
                    <Text>{cellValues.value?.name}</Text>
            )
        }}] : [],
        {field: "warehouse", headerName: t("warehouse") , flex:2, cellClassName: "warehouse", filter: WEBSHOP_FILTER_KEYS.WAREHOUSE, renderCell : (cellValues) => {
            if(cellValues.row.skeleton) {
                return <ShTextSkeleton/>
            }

            return (
                <Text  >{cellValues.value?.name}</Text>
            )
        }},
        {
            field: "state", 
            headerName: t("status"),
            flex:1,
            renderCell: (params) => {
                if(params.row.skeleton) {
                    return <ShLabelSkeleton/>
                }

                const labelColor = params.row.state === "active" ? "green" : theme.palette.mode === "dark" ? "greyLight" : "grey";
              
                return (
                    <ShLabel size={32} palette="normal" variant={labelColor}>
                      {t(params.row.state)}
                    </ShLabel>
                  );
              }
        },
        {field: "createdAt", headerName: t("created_at") , flex:1, renderCell : (cellValues) => {
            if(cellValues.row.skeleton) {
                return <ShTextSkeleton/>
            }

            let date = new Date(cellValues.row.createdAt).toLocaleDateString(i18n.language);

            return (
                <Text>{date}</Text>
            )
        }},
        {
            field: "phoneView", 
            headerName: "PhoneView",
            cellClassName: "phone-column--cell",
            renderCell: (cellValues) => {
                if(cellValues.row.skeleton) {
                    return <ShTextSkeleton/>
                }

                return (
                    <RelationWebshopIntegrationCard 
                        skeleton={cellValues.row.skeleton ?? false} 
                        {...cellValues.row}
                        onClick={() => getWebshopCredentialDetails(cellValues)}
                    />
                )
            }
        }
    ];

    return (
        <Box
            sx={{
                height:1,
                "@media screen and (max-width: 47.9375em)" : {
                    paddingTop:0,
                    paddingX:0,
                }
            }}
        >
            
            <ShDataGrid2 key={theme.palette.mode}
                content={useGetWebshopCredentialsQuery}
                config={config}
                gridActions={<GridActions handleOpen={() => setAddModalOpen(true)} hasCreatePermission={hasCreatePermission}></GridActions>}
                title={t("saleschannels")}
                gridOptions={gridOptions}
                sortModel={{field: columns[4].field,type:"DESC"}}
                columns={columns}
                onRowClick={getWebshopCredentialDetails}
                selectable={hasCreatePermission}
                setSelected={onSelected}
                keepSelectedAlive
                keepNonExistentRowsSelected
                selectedItems={selectedItems}
                selectedActions={
                    <ShDataGridSelectedActions selectedItems={selectedItems}>
                        {hasCreatePermission && (
                            <DropdownButton
                                onClick={() => activateModal.setOpen(true)}
                                icon={<PowerSettingsNewIcon/>}
                                text={t("activate_saleschannels")}
                            />
                        )}
                    </ShDataGridSelectedActions>
                }
                isRowSelectable={(row) => hasCreatePermission && row.state === general_states.CONCEPT}>
            </ShDataGrid2>

            <MConfirmation
                open={activateModal.open}
                handleClose={() => setActivateModalOpen(false)}
                title={t("activate_saleschannels")}
                content={t("activate_saleschannels_text")}
                confirm={() => handleActivateWebshops()}
            />

            <MpAddWebshop onOpen={() => addModal.setOpen(true)} onClose={() => addModal.setOpen(false)} open={addModal.open} handleClose={handleClose}/>

            {spLoading && 
                <SpWebshopCredentialsDetails
                    isExtended={isExtended}
                    setIsExtended={setIsExtended}
                    webshopCredentialsId={webshopCredentialsId}
                    // data={credentialData}     
                /> 
            }
        </Box>
    )
};

export default Concept;